var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortDescIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 10,
    viewBox: "0 0 4 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.49688e-07 1.16609L5.83314e-08 8.50048C0.000656418 8.63211 0.0402198 8.76061 0.113704 8.86977C0.187189 8.97892 0.291306 9.06387 0.412935 9.11389C0.534225 9.16494 0.667904 9.17889 0.797105 9.15398C0.926307 9.12906 1.04524 9.06639 1.1389 8.97387L3.80299 6.3069C3.86542 6.24492 3.91497 6.17118 3.94878 6.08993C3.98259 6.00868 4 5.92153 4 5.83351C4 5.7455 3.98259 5.65835 3.94878 5.5771C3.91497 5.49585 3.86542 5.42211 3.80299 5.36013C3.74108 5.29763 3.66741 5.24803 3.58625 5.21418C3.50509 5.18033 3.41804 5.16291 3.33012 5.16291C3.24219 5.16291 3.15514 5.18033 3.07398 5.21418C2.99282 5.24803 2.91916 5.29763 2.85724 5.36013L1.33205 6.89363L1.33205 1.16609C1.33205 0.98926 1.26188 0.819671 1.13697 0.694632C1.01207 0.569594 0.842663 0.499349 0.666023 0.499349C0.489382 0.499349 0.319978 0.569594 0.195074 0.694633C0.0701705 0.819671 -3.57417e-07 0.98926 -3.49688e-07 1.16609Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDescIcon);
export default __webpack_public_path__ + "static/media/sort-desc-icon.58941569bf565f961391d47e93207379.svg";
export { ForwardRef as ReactComponent };